import React, { useContext, useId, useState } from 'react';
import { TabsContextProps, TabsContextShape } from './types';

const TabsContext = React.createContext({ activeTabIndex: 0, baseId: '' } as TabsContextShape);

const TabsProvider = ({
  children,
  defaultActiveIndex,
  onActiveIndexChange,
}: React.PropsWithChildren<TabsContextProps>) => {
  const [activeTabIndex, setActiveTabIndex] = useState(defaultActiveIndex ?? 0);
  const baseId = useId();

  return (
    <TabsContext.Provider value={{ activeTabIndex, setActiveTabIndex, onActiveIndexChange, baseId }}>
      {children}
    </TabsContext.Provider>
  );
};

export default TabsProvider;

export const useTabs = () => useContext(TabsContext);
